// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.showcase-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 24px;
}

.showcase-form input,
.showcase-form textarea {
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #333;
  background: #1b1b1b;
  color: #f5f5f5;
}

.showcase-form textarea {
  min-height: 100px;
  resize: vertical;
}

.form-buttons {
  display: flex;
  gap: 10px;
}

.form-buttons button {
  padding: 8px 14px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  background: #2e2e2e;
  color: #f5f5f5;
}

.form-buttons .primary {
  background: #4f46e5;
  color: #fff;
}

.showcase-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.showcase-item {
  border: 1px solid #2a2a2a;
  border-radius: 10px;
  padding: 16px;
  background: #141414;
}

.showcase-item-main {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.showcase-item-main strong {
  font-size: 18px;
}

.showcase-item-main span {
  color: #c7c7c7;
  white-space: pre-wrap;
}

.showcase-thumb {
  width: 100%;
  max-width: 320px;
  border-radius: 10px;
  border: 1px solid #262626;
  object-fit: cover;
}

.showcase-item-actions {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}

.showcase-item-actions button {
  padding: 8px 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  background: #2e2e2e;
  color: #f5f5f5;
}

.showcase-item-actions .danger {
  background: #b91c1c;
  color: #fff;
}

.showcase-comments {
  margin-top: 12px;
}

.showcase-comments button {
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #333;
  background: #181818;
  color: #ddd;
  cursor: pointer;
}

.comment-box {
  margin-top: 10px;
  padding: 10px;
  border-radius: 8px;
  background: #101010;
  border: 1px solid #262626;
}

.comment-input {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
}

.comment-input input {
  flex: 1 1;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #333;
  background: #141414;
  color: #f5f5f5;
}

.comment-input button {
  padding: 8px 12px;
  border-radius: 6px;
  border: none;
  background: #4f46e5;
  color: #fff;
  cursor: pointer;
}

.comment-box ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.comment-box li {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  border-radius: 6px;
  background: #161616;
}

.comment-box li span {
  font-size: 13px;
  color: #a3a3a3;
}

.comment-box li p {
  margin: 0;
  color: #f5f5f5;
}

.comment-box li button {
  align-self: flex-end;
  padding: 4px 8px;
  border-radius: 6px;
  border: none;
  background: #b91c1c;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/AppShowcaseManage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;AACjB","sourcesContent":[".showcase-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 24px;\n}\n\n.showcase-form input,\n.showcase-form textarea {\n  width: 100%;\n  padding: 10px;\n  border-radius: 6px;\n  border: 1px solid #333;\n  background: #1b1b1b;\n  color: #f5f5f5;\n}\n\n.showcase-form textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n.form-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.form-buttons button {\n  padding: 8px 14px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  background: #2e2e2e;\n  color: #f5f5f5;\n}\n\n.form-buttons .primary {\n  background: #4f46e5;\n  color: #fff;\n}\n\n.showcase-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.showcase-item {\n  border: 1px solid #2a2a2a;\n  border-radius: 10px;\n  padding: 16px;\n  background: #141414;\n}\n\n.showcase-item-main {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.showcase-item-main strong {\n  font-size: 18px;\n}\n\n.showcase-item-main span {\n  color: #c7c7c7;\n  white-space: pre-wrap;\n}\n\n.showcase-thumb {\n  width: 100%;\n  max-width: 320px;\n  border-radius: 10px;\n  border: 1px solid #262626;\n  object-fit: cover;\n}\n\n.showcase-item-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.showcase-item-actions button {\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  background: #2e2e2e;\n  color: #f5f5f5;\n}\n\n.showcase-item-actions .danger {\n  background: #b91c1c;\n  color: #fff;\n}\n\n.showcase-comments {\n  margin-top: 12px;\n}\n\n.showcase-comments button {\n  padding: 6px 10px;\n  border-radius: 6px;\n  border: 1px solid #333;\n  background: #181818;\n  color: #ddd;\n  cursor: pointer;\n}\n\n.comment-box {\n  margin-top: 10px;\n  padding: 10px;\n  border-radius: 8px;\n  background: #101010;\n  border: 1px solid #262626;\n}\n\n.comment-input {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.comment-input input {\n  flex: 1;\n  padding: 8px;\n  border-radius: 6px;\n  border: 1px solid #333;\n  background: #141414;\n  color: #f5f5f5;\n}\n\n.comment-input button {\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: none;\n  background: #4f46e5;\n  color: #fff;\n  cursor: pointer;\n}\n\n.comment-box ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.comment-box li {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 8px;\n  border-radius: 6px;\n  background: #161616;\n}\n\n.comment-box li span {\n  font-size: 13px;\n  color: #a3a3a3;\n}\n\n.comment-box li p {\n  margin: 0;\n  color: #f5f5f5;\n}\n\n.comment-box li button {\n  align-self: flex-end;\n  padding: 4px 8px;\n  border-radius: 6px;\n  border: none;\n  background: #b91c1c;\n  color: #fff;\n  cursor: pointer;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
